import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { and } from '@adornis/validation/functions/and.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { min } from '@adornis/validation/functions/range.js';
import { ChancenBriefVariableValue } from './LogistikOrder.js';
import { LogistikProduct } from './LogistikProduct.js';
import { type LogistikProductCategory } from './enums/LogistikEnums.js';

/**
 * @entity LogistikCart
 */
@Entity()
export class LogistikCart extends AdornisEntity {
  public static override _class = 'HubCart'; // TODO needs migration before we can change this

  @Field(type => [LogistikCartItem], { default: v => v ?? [] })
  public items!: LogistikCartItem[];

  @Field(type => Int)
  public studentCount?: number;
}

/**
 * @entity LogistikCartItem
 */
@Entity()
export class LogistikCartItem extends AdornisEntity {
  public static override _class = 'HubCartItem'; // TODO needs migration before we can change this

  @Field(type => ID, { default: v => v ?? A.getGloballyUniqueID() })
  public _id!: string;

  @Field(type => String)
  public productID!: string;

  @DataLoadedField(type => LogistikProduct, ({ productID }) => productID)
  public product!: LogistikProduct;

  @Field(type => String)
  public productCategory!: LogistikProductCategory;

  @Field(type => Int)
  public quantity!: number;

  @Field(type => [ChancenBriefVariableValue], { default: v => v ?? [] })
  flyaVariableValues: Maybe<ChancenBriefVariableValue[]>;
}

@Entity()
export class LogistikLearningMaterialCartItem extends LogistikCartItem {
  static override _class = 'LogistikLearningMaterialCartItem';

  @Field(type => Boolean)
  public isDigital!: boolean;
}

@Entity()
export class LogistikChancenBriefCartItem extends LogistikCartItem {
  static override _class = 'LogistikChancenBriefCartItem';
  @Field(type => Boolean, { default: v => v ?? false })
  public isSelfPrint!: boolean;
}

export class LogistikWorkshoppackCartiItem extends LogistikCartItem {
  static override _class = 'LogistikWorkshoppackCartiItem';

  @validate(
    and(
      nonOptional({ translationKey: 'Bitte wählen Sie die Anzahl der Trainer:innen' }),
      min(1, 'Mindest Anzahl der Trainer:innen wurde nicht erreicht'),
    ),
  )
  @Field(type => Int)
  public trainersQuantity!: number;

  @validate(
    and(
      nonOptional({ translationKey: 'Bitte wählen Sie die Anzahl die Teilnehmenden' }),
      min(1, 'Mindest Anzahl der Teilnehmenden wurde nicht erreicht'),
    ),
  )
  @Field(type => Int)
  public participantsQuantity!: number;
}
